import React, { useState, useRef } from 'react';
import { useApp } from '../context/AppContext';
import { PLAN_LIMITS } from '../data/initialState';
import { supabase } from '../supabase';
import ProScreen from '../components/ProScreen';
import TabHjem from '../components/TabHjem';
import TabMaal from '../components/TabMaal';
import TabBudsjett from '../components/TabBudsjett';
import TabChat from '../components/TabChat';
import TabProfil from '../components/TabProfil';
import TabUkerapport from '../components/TabUkerapport';
import TabSosial from '../components/TabSosial';
import TabKalender from '../components/TabKalender';
import XpPopup from '../components/XpPopup';
import AchievementPopup from '../components/AchievementPopup';

const getTabs = (lang, plan) => {
  const L = {
    home:     { en:'Home',     no:'Hjem',     sv:'Hem',      da:'Hjem' },
    goals:    { en:'Goals',    no:'Mål',      sv:'Mål',      da:'Mål' },
    budget:   { en:'Budget',   no:'Budsjett', sv:'Budget',   da:'Budget' },
    calendar: { en:'Calendar', no:'Kalender', sv:'Kalender', da:'Kalender' },
    report:   { en:'Report',   no:'Rapport',  sv:'Rapport',  da:'Rapport' },
    profile:  { en:'Profile',  no:'Profil',   sv:'Profil',   da:'Profil' },
    social:   { en:'Social',   no:'Sosialt',  sv:'Socialt',  da:'Socialt' },
    coach:    { en:lang==='en'?'AI Coach':lang==='sv'?'AI Coach':lang==='da'?'AI Coach':'AI Coach',    no:lang==='en'?'AI Coach':lang==='sv'?'AI Coach':lang==='da'?'AI Coach':'AI Coach',    sv:lang==='en'?'AI Coach':lang==='sv'?'AI Coach':lang==='da'?'AI Coach':'AI Coach',    da:lang==='en'?'AI Coach':lang==='sv'?'AI Coach':lang==='da'?'AI Coach':'AI Coach' },
    week:     { en:'Report',   no:'Rapport',  sv:'Rapport',  da:'Rapport' },
  };
  const l = lang || 'en';
  return (() => {
    const isPaid = plan === 'advanced' || plan === 'premium';
    const baseTabs = [
      { id:'hjem',     label: L.home[l],     icon:'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z M9 22V12h6v10' },
      { id:'maal',     label: L.goals[l],    icon:'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z M12 6a6 6 0 1 0 0 12A6 6 0 0 0 12 6z M12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4z' },
      { id:'budsjett', label: L.budget[l],   icon:'M2 8h20M2 8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8z M6 12h4' },
      { id:'kalender', label: L.calendar[l], icon:'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z' },
    ];
    if (isPaid) {
      baseTabs.push(
        { id:'chat',    label:lang==='en'?'AI Coach':lang==='sv'?'AI Coach':lang==='da'?'AI Coach':'AI Coach',       icon:'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z' },
        { id:'rapport', label: L.report[l], icon:'M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 2h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2z' }
      );
    } else {
      baseTabs.push(
        { id:'pro', label:'Pro 🔒', icon:'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z', isPro:true }
      );
    }
    baseTabs.push(
      { id:'sosial',  label: L.social[l],  icon:'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2 M23 21v-2a4 4 0 0 0-3-3.87 M16 3.13a4 4 0 0 1 0 7.75 M9 7a4 4 0 1 0 0 8 4 4 0 0 0 0-8z' },
      { id:'profil',  label: L.profile[l], icon:'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2 M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z' }
    );
    return baseTabs;
  })()
};

function UpsellModal({ onClose, dispatch, lang }) {
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'flex-end', justifyContent:'center', zIndex:9999 }}>
      <div style={{ background:'var(--card)', borderRadius:'24px 24px 0 0', padding:'1.5rem 1.25rem 2rem', width:'100%', maxWidth:480 }}>
        <div style={{ width:40, height:4, background:'var(--border)', borderRadius:999, margin:'0 auto 1.25rem' }}/>

        <div style={{ textAlign:'center', marginBottom:'1.25rem' }}>
          <div style={{ fontSize:36, marginBottom:8 }}>🚀</div>
          <div style={{ fontFamily:'var(--font-display)', fontSize:22, fontWeight:800, color:'var(--ink)', position:'relative', display:'inline-block' }}>
            {lang==='en'?'Unlock Premium':lang==='sv'?'Lås upp Premium':lang==='da'?'Lås op for Premium':'Lås opp Premium'}
            <span style={{ fontSize:14, position:'absolute', top:-8, right:-20 }}>👑</span>
          </div>
          <div style={{ fontSize:13, color:'var(--ink3)', marginTop:6 }}>
            {lang==='en'?'Get the full Savely experience':lang==='sv'?'Få hela Savely-upplevelsen':lang==='da'?'Få hele Savely-oplevelsen':'Få hele Savely-opplevelsen'}
          </div>
        </div>

        <div style={{ display:'flex', flexDirection:'column', gap:10, marginBottom:'1.25rem' }}>
          {[
            { emoji:'📊', title: lang==='en'?'Weekly Report':lang==='sv'?'Veckorapport':lang==='da'?'Ugerapport':'Ukerapport', desc: lang==='en'?'Full spending analysis with charts':lang==='sv'?'Full utgiftsanalys med grafer':lang==='da'?'Fuld udgiftsanalyse med grafer':'Full utgiftsanalyse med grafer' },
            { emoji:'🤖', title: lang==='en'?'AI Finance Coach':lang==='sv'?'AI-ekonomicoach':lang==='da'?'AI-finanscoach':'AI Økonomicoach', desc: lang==='en'?'Personal AI coach that knows your goals':lang==='sv'?'Personlig AI-coach som känner dina mål':lang==='da'?'Personlig AI-coach der kender dine mål':'Personlig AI-coach som kjenner dine mål' },
            { emoji:'🎯', title: lang==='en'?'Daily Challenges':lang==='sv'?'Dagliga utmaningar':lang==='da'?'Daglige udfordringer':'Daglige utfordringer', desc: lang==='en'?'Personal saving challenges every day':lang==='sv'?'Personliga sparutmaningar varje dag':lang==='da'?'Personlige sparudfordringer hver dag':'Personlige spareutfordringer hver dag' },
            { emoji:'🎨', title: lang==='en'?'Premium Themes':lang==='sv'?'Premium-teman':lang==='da'?'Premium-temaer':'Premium-temaer', desc: lang==='en'?'3 exclusive premium color themes':lang==='sv'?'3 exklusiva premium-färgteman':lang==='da'?'3 eksklusive premium-farvetemaer':'3 eksklusive premium-fargetemaer' },
          ].map((f,i) => (
            <div key={i} style={{ display:'flex', alignItems:'flex-start', gap:12, padding:'10px 12px', background:'var(--surface)', borderRadius:12 }}>
              <div style={{ fontSize:24, flexShrink:0 }}>{f.emoji}</div>
              <div>
                <div style={{ fontSize:13, fontWeight:700, color:'var(--ink)', marginBottom:2 }}>{f.title}</div>
                <div style={{ fontSize:11, color:'var(--ink3)' }}>{f.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <button onClick={() => { dispatch({ type:'SET_PLAN', payload:'premium' }); onClose(); }}
          style={{ width:'100%', padding:'14px', background:'linear-gradient(135deg,#7C3AED,#A855F7)', color:'#fff', border:'none', borderRadius:14, fontFamily:'var(--font-display)', fontSize:16, fontWeight:800, cursor:'pointer', marginBottom:10, boxShadow:'0 4px 20px rgba(124,58,237,0.4)' }}>
          {lang==='en'?'👑 Get Premium →':lang==='sv'?'👑 Välj Premium →':lang==='da'?'👑 Vælg Premium →':'👑 Velg Premium →'}
        </button>

        <button onClick={onClose} style={{ width:'100%', padding:'12px', background:'transparent', border:'none', color:'var(--ink3)', cursor:'pointer', fontSize:13 }}>
          {lang==='en'?'Maybe later':lang==='sv'?'Kanske senare':lang==='da'?'Måske senere':'Kanskje senere'}
        </button>
      </div>
    </div>
  );
}



export default function MainApp() {
  const ctx = useApp();
  const state = ctx?.state || {};
  const dispatch = ctx?.dispatch || (() => {});
  const lang = state?.language || 'en';
  const [active, setActive] = useState('hjem');
  const [showUpsell, setShowUpsell] = useState(false);
  // Inline sync functions - safe against undefined state
  const syncTransaction = async (tx) => {
    if (!state?.user?.id) return;
    try { await supabase.from('transactions').upsert({...tx, user_id: state.user.id}); } catch(e) {}
  };
  const syncGoal = async (goal) => {
    if (!state?.user?.id) return;
    try { await supabase.from('goals').upsert({...goal, user_id: state.user.id}); } catch(e) {}
  };
  const syncAchievement = async (id) => {
    if (!state?.user?.id) return;
    try { await supabase.from('achievements').upsert({id, user_id: state.user.id, unlocked: true}); } catch(e) {}
  };
  const syncIncome = async (income, expenses, payDay) => {
    if (!state?.user?.id) return;
    try { await supabase.from('profiles').upsert({id: state.user.id, income, expenses, pay_day: payDay}); } catch(e) {}
  };

  const syncSubscription = async (sub, action) => {
    if (!state?.user?.id) return;
    try {
      if (action === 'add') {
        await supabase.from('subscriptions').upsert({
          id: String(sub.id), user_id: state.user.id,
          name: sub.name, amount: sub.amount, category: sub.cat || 'Other'
        });
      } else if (action === 'delete') {
        await supabase.from('subscriptions').delete().eq('id', String(sub.id));
      }
    } catch(e) { console.error('Sync sub error:', e); }
  };

  const tabs = getTabs(lang, state.plan);

  const renderTab = () => {
    switch (active) {
      case 'pro':      return <ProScreen onUpgrade={() => { dispatch({ type:'SET_PLAN', payload:'premium' }); setActive('profil'); }}/>;
      case 'hjem':     return <TabHjem onNav={setActive} syncTransaction={syncTransaction} syncGoal={syncGoal}/>;
      case 'maal':     return <TabMaal onNav={setActive}/>;
      case 'budsjett': return <TabBudsjett syncSubscription={syncSubscription}/>;
      case 'kalender': return <TabKalender/>;
      case 'rapport':  return <TabUkerapport/>;
      case 'chat':     return <TabChat/>;
      case 'sosial':   return <TabSosial/>;
      case 'profil':   return <TabProfil syncIncome={syncIncome} syncAchievement={syncAchievement}/>;
      default:         return <TabHjem onNav={setActive} syncTransaction={syncTransaction} syncGoal={syncGoal}/>;
    }
  };

  return (
    <div style={{ minHeight:'100dvh', background:'var(--bg)', display:'flex', flexDirection:'column' }}>
      {showUpsell && <UpsellModal onClose={() => setShowUpsell(false)} dispatch={dispatch} lang={lang}/>}
      {state.xpAnim > 0 && <XpPopup xp={state.xpAnim}/>}
      {state.achUnlocked && <AchievementPopup ach={state.achUnlocked} onDone={() => dispatch({ type:'CLEAR_ACH_POPUP' })}/>}

      {/* Main content */}
      <div style={{ flex:1, overflowY:'auto', paddingBottom:70 }}>
        {renderTab()}
      </div>

      {/* Tab bar */}
      <div style={{ position:'fixed', bottom:0, left:'50%', transform:'translateX(-50%)', width:'100%', maxWidth:480, background:'var(--card)', borderTop:'1px solid var(--border)', display:'flex', zIndex:100 }}>
        {tabs.map(tab => {
          const isActive = active === tab.id;
          return (
            <button key={tab.id} onClick={() => setActive(tab.id)} style={{
              flex:1, display:'flex', flexDirection:'column', alignItems:'center',
              justifyContent:'center', padding:'8px 4px 10px', background:'transparent',
              border:'none', cursor:'pointer', position:'relative',
              color: isActive ? 'var(--accent)' : 'var(--ink3)',
            }}>
              {tab.id === 'pro' && (
                <div style={{ position:'absolute', top:4, right:'50%', transform:'translateX(8px)', background:'#7C3AED', color:'#fff', fontSize:7, fontWeight:800, borderRadius:999, padding:'1px 4px' }}>PRO</div>
              )}
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={isActive?2.5:2} strokeLinecap="round" strokeLinejoin="round">
                <path d={tab.icon}/>
              </svg>
              <div style={{ fontSize:9, fontWeight: isActive ? 700 : 500, marginTop:2 }}>{tab.label}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
